import type { Locale } from '@iac/contracts';
import type { Story } from '../../lib/story';

/**
 * Every story in the tree. Eager, like `AG5_SCRIPTS`: routes, navigation and
 * the home page all need titles up front, and the components a story renders
 * are in the bundle anyway.
 */
const modules = import.meta.glob<{ default: Story }>(
  ['../../components/*.stories.tsx', '../../styles/*.stories.tsx'],
  { eager: true },
);

export interface CatalogEntry {
  /** URL segment under `/library`, from the file name: `DataTable` → `data-table`. */
  slug: string;
  story: Story;
}

function slugOf(path: string): string {
  const base = path.slice(path.lastIndexOf('/') + 1, -'.stories.tsx'.length);
  return base.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

export const STORIES: CatalogEntry[] = Object.entries(modules).map(
  ([path, module]) => ({ slug: slugOf(path), story: module.default }),
);

/** One section's stories, alphabetical in the language the screen renders in. */
export function storiesOf(kind: Story['kind'], locale: Locale): CatalogEntry[] {
  return STORIES.filter((entry) => entry.story.kind === kind).sort((a, b) =>
    a.story.title[locale].localeCompare(b.story.title[locale], locale),
  );
}
